import { sha256 } from 'js-sha256';

// Состояние гостя в пределах вкладки. sessionStorage переживает перезагрузку и выгрузку
// вкладки мобильным браузером, но не делится между вкладками, поэтому две вкладки
// остаются разными участниками.
const UDID_KEY = 'forum_udid';
const AGREED_KEY = 'forum_guest_agreed';
const JOINED_ROOMS_KEY = 'forum_joined_rooms';

const memory = {};

function read(key) {
  try {
    const value = window.sessionStorage.getItem(key);
    if (value !== null) {
      return value;
    }
  } catch (e) {
    // sessionStorage недоступен (приватный режим, запрет cookies) — работаем из памяти.
  }
  return Object.prototype.hasOwnProperty.call(memory, key) ? memory[key] : null;
}

function write(key, value) {
  memory[key] = value;
  try {
    window.sessionStorage.setItem(key, value);
  } catch (e) {
    // значение останется в памяти до перезагрузки страницы
  }
}

export function getUdid() {
  let udid = read(UDID_KEY);
  if (!udid) {
    udid = sha256('web' + new Date().getTime() + Math.random());
    write(UDID_KEY, udid);
  }
  return udid;
}

export function isGuestAgreed() {
  return read(AGREED_KEY) === '1';
}

export function setGuestAgreed(agreed) {
  write(AGREED_KEY, agreed ? '1' : '0');
}

function getJoinedRooms() {
  try {
    const rooms = JSON.parse(read(JOINED_ROOMS_KEY) || '[]');
    return Array.isArray(rooms) ? rooms : [];
  } catch (e) {
    return [];
  }
}

export function hasJoinedRoom(roomCode) {
  return Boolean(roomCode) && getJoinedRooms().includes(roomCode);
}

export function markRoomJoined(roomCode) {
  if (!roomCode || hasJoinedRoom(roomCode)) {
    return;
  }
  write(JOINED_ROOMS_KEY, JSON.stringify([...getJoinedRooms(), roomCode]));
}

export function forgetRoom(roomCode) {
  write(JOINED_ROOMS_KEY, JSON.stringify(getJoinedRooms().filter((code) => code !== roomCode)));
}
